import React from 'react';

interface SliderProps {
  label?: string;
  min: number;
  max: number;
  step: number;
  value: number;
  onChange: (value: number) => void;
  formatValue?: (value: number) => React.ReactNode;
  unit?: string;
  error?: string;
  required?: boolean;
  className?: string;
}

const Slider: React.FC<SliderProps> = ({
  label,
  min,
  max,
  step,
  value,
  onChange,
  formatValue,
  unit = '',
  error,
  required = false,
  className = '',
}) => {
  return (
    <div className={`space-y-2 ${label ? 'mt-6' : ''} ${className}`}>
      {label && (
        <label className="block text-base font-semibold text-gray-700 mb-0.5">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      
      <div className="flex items-center gap-4">
        <div className="flex-1">
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={(e) => onChange(Number(e.target.value))}
            className="w-full finlo-slider"
            style={{
              background: `linear-gradient(to right, rgb(33, 43, 244) 0%, rgb(33, 43, 244) ${((value - min) / (max - min)) * 100}%, rgb(187, 187, 187) ${((value - min) / (max - min)) * 100}%, rgb(187, 187, 187) 100%)`
            }}
          />
        </div>
        
        {formatValue ? (
          formatValue(value)
        ) : (
          <div className="flex items-center gap-1 min-w-0">
            <span className="text-lg font-medium text-gray-900">
              {value.toLocaleString()}
            </span>
            {unit && <span className="text-sm text-gray-500">{unit}</span>}
          </div>
        )}
      </div>
      
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}
    </div>
  );
};

export default Slider;
